goog.provide('el8.apphome.scheduler.util');

goog.require('el8.service.tz');

el8.apphome.scheduler.util = (function() {

    return {

        getClosestIntervalTime: function(_time, interval) {
            /**
             * NOTE: This ASSUMES that intervals are divisors of 60. Does 
             * nothing if that's not true.
             *
             * Gets closest interval LESS THAN OR EQ time arg
             */
            if (parseFloat(60/interval) !== parseInt(60/interval, 10)) {
                return;
            }
            var hours = _time.getHours();
            var minutes = _time.getMinutes();
            var curr = 60;
            while (curr >= 0) {
                if (minutes >= curr) {
                    break;
                }
                curr -= interval;
            }
            return el8.service.tz.newTzTime(hours, curr);
        },

        getPrevMondayDate: function(date) {
            /** 
             * If date is a Monday, return a copy of date.
             * Otherwise, return the date of the previous Monday.
             */
            var newDate = el8.service.tz.newTzDate(date);
            // date.getDay() === 1 on Monday (0-indexed from Sunday)
            // setDate is also smart enough to deal with month boundaries
            if (date.getDay() === 0) {
                newDate.setDate(date.getDate() - 6);
                // Sundays (day is 0) would give you next Monday by the defn below
            } else if (date.getDay() !== 1) {
                newDate.setDate(date.getDate() - date.getDay() + 1);
            }
            return newDate;
        },

        getApptStrId: function(appt) {
            return appt.getUserId() + ' ' + 
                el8.service.tz.asDateTimeStr(appt.getApptTime());
        },

        getDateStrId: function(_date) {
            return el8.service.tz.asDateStr(_date);
        },

        getTimeStrId: function(_time) {
            return el8.service.tz.asTimeStr(_time);
        },

        getTimeFromTimeStr: function(str) {
            var hours = str.substring(0, 2)*1;
            var minutes = str.substring(2)*1;
            return el8.service.tz.newTzTime(hours, minutes, 0);
        },

        // This map specifies which statuses have additional data (applied via the quick select
        // dialog). See apptStatusDetails for the list of options.
        getStatusMap: function() {
            var statusMap = {
                'inRoom': {
                    text: 'Specify room',
                    prefix: 'Room: ',
                    // if useRoom is true, we will keep roomId populated when switching
                    useRoom: true
                },
                'vitalsTaken': {
                    text: 'Specify room',
                    prefix: 'Room: ',
                    useRoom: true
                },
                'notSeen': {
                    text: 'Specify reason',
                    prefix: 'Reason: ',
                    // if useNote is true, then it will keep statusNote populated when switching status
                    useNote: true
                }
            };
            return statusMap;
        },

        getPrimaryPhysicianId: function() {
            if (el8.data.currUser.isPhysician()) {
                return el8.data.currUser.getId();
            } else {
                if (el8.data.practiceUsers.getPhysicianUsers().length) {
                    var defaultPhysicianUserId = 
                        el8.data.currUser.getDefaultPhysicianUserId() ||
                        el8.data.practiceUsers.getPhysicianUsers()[0].id;
                    return defaultPhysicianUserId;
                }
            }
        },

        convertVirtualEventId: function(str) {
            // sample: 119938023510_01202012
            var strs = str.split('_');
            return {
                scheduleId: strs[0]*1,
                eventDate: el8.service.tz.newTzDate(
                        strs[1].substring(4)*1,    // years
                        strs[1].substring(0, 2)*1 - 1, // months
                        strs[1].substring(2, 4)*1  // days
                    )
            };
        },

        /**
         * A spinner positioned over the center of the bodyContainer
         */
        getLoadingDiv: function(bodyContainer) {
            var $loadingDiv = $('<div class="el8Loading"></div>');
            $loadingDiv.css({
                position: 'absolute',
                width: '20px',
                top: bodyContainer.height() / 2 - $loadingDiv.height(),
                left: bodyContainer.width() / 2
            });
            return $loadingDiv;
        },

        setupActionMenus: function (container, anchorTop, menuIdKey) {
            var menus = {
                'openVirtualOrTimeblock': null,
                'normalAppt': null
            };

            menus['openVirtualOrTimeblock'] = new el8.uiwidget.NewActionsMenu({
                container: container,
                anchorTop: anchorTop,
                menuId: menuIdKey + '-menu-open-virt-timeblock',
                offsets: { top: 21, left: 0 },
                width: 155
            });

            menus['normalAppt'] = new el8.uiwidget.NewActionsMenu({
                container: container,
                anchorTop: anchorTop,
                menuId: menuIdKey + '-menu-normal-appt',
                offsets: { top: 21, left: 0 },
                width: 165,
                twoColumn: false
            });

            return menus;
        },

        displayMenu: function (target, actionMenu, menus, itemId) {
            var $target = $(target);

            // 1 col if open time, virtual event, or timeblock, 2 col otherwise
            var item = itemId ? el8.practicedata.appts.getById(itemId*1) : null;
            if (!item || item.isTimeBlock()) {
                menus['openVirtualOrTimeblock'].display($target,
                                    null,
                                    {top: 17, left: 10},
                                    actionMenu);
            } else {
                menus['normalAppt'].display($target,
                                    null,
                                    {top: 17, left: 10},
                                    actionMenu);
            }
        }
    };
})();

